<div>
  <div class="row">
    <div class="col col-1 bold">
      Bedrijfsopbrengsten
    </div>
    <div class="col-2 bold">
      Huidige periode
    </div>
    <div class="col-3 bold">
      Vorige periode
    </div>
  </div>
</div>
<div class="pt-3"></div>
<form [formGroup]="totalNettoOmzetFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Netto-omzet</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalWaardeveranderingenVoorraadFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Wijziging in voorraden gereed product en onderhanden werk</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalGeactiveerdeProductieEigenBedrijfFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Geactiveerde productie ten behoeve van het eigen bedrijf</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalPriveGebruikEigenBedrijfFg">
  <div *ngIf="!this.isRechtspersoon">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Privé gebruik eigen bedrijf</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </div>
</form>
<form [formGroup]="totalExploitatiesubsidiesFg">
  <div class="row" *ngIf="this.isRechtspersoon">
    <div class="col col-1">
      <p style="padding: 6px">Exploitatiesubsidies</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalOverigeBedrijfsopbrenstenFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Overige bedrijfsopbrengsten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="somBedrijfsopbrengstenFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px"><b>Totaal van bedrijfsopbrengsten</b></p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<div class="row">
  <div class="col col-1 bold">Bedrijfslasten</div>
  <div class="col-2 bold">
  </div>
</div>
<div class="pt-3"></div>
<form [formGroup]="totalKostenGrondEnHulpstoffenFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Kosten van grond- en hulpstoffen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalKostenUitbesteedWerkFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Kosten uitbesteed werk en andere externe kosten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalLastenPersoneelsbeloningenFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Lasten uit hoofde van personeelsbeloningen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalAfschrijvingenIvaMvaFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Afschrijvingen op immateriële en materiële vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalWaardeveranderingenIvaMvaFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Waardeveranderingen van immateriële en materiële vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalWaardeveranderingenVastgoedbeleggingenFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Wijziging in de reële waarde van vastgoedbeleggingen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<!--<form [formGroup]="totalWaardeveranderingenBeleggingenGerealiseerdFg">-->
<!--    <div class="row">-->
<!--      <div class="col col-1">-->
<!--        <p style="padding: 6px">Gerealiseerde waardeveranderingen van beleggingen</p>-->
<!--      </div>-->
<!--      <div class="col-2">-->
<!--        <snelstart-ui-number-form-control formControlName="valuePeriod1"-->
<!--                                          class="custom-input-150 custom-readonly"-->
<!--                                          align="right"-->
<!--                                          prefix="€"-->
<!--                                          [showAllDecimals]="false"-->
<!--                                          [disabledControl]="true"-->
<!--        >-->
<!--        </snelstart-ui-number-form-control>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        <snelstart-ui-number-form-control formControlName="valuePeriod2"-->
<!--                                          class="custom-input-150 custom-readonly"-->
<!--                                          align="right"-->
<!--                                          prefix="€"-->
<!--                                          [showAllDecimals]="false"-->
<!--                                          [disabledControl]="true"-->
<!--        >-->
<!--        </snelstart-ui-number-form-control>-->
<!--      </div>-->
<!--    </div>-->
<!--</form>-->
<!--<form [formGroup]="totalWaardeveranderingenBeleggingenNietGerealiseerdFg">-->
<!--    <div class="row">-->
<!--      <div class="col col-1">-->
<!--        <p style="padding: 6px">Niet-gerealiseerde waardeveranderingen van beleggingen</p>-->
<!--      </div>-->
<!--      <div class="col-2">-->
<!--        <snelstart-ui-number-form-control formControlName="valuePeriod1"-->
<!--                                          class="custom-input-150 custom-readonly"-->
<!--                                          align="right"-->
<!--                                          prefix="€"-->
<!--                                          [showAllDecimals]="false"-->
<!--                                          [disabledControl]="true"-->
<!--        >-->
<!--        </snelstart-ui-number-form-control>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        <snelstart-ui-number-form-control formControlName="valuePeriod2"-->
<!--                                          class="custom-input-150 custom-readonly"-->
<!--                                          align="right"-->
<!--                                          prefix="€"-->
<!--                                          [showAllDecimals]="false"-->
<!--                                          [disabledControl]="true"-->
<!--        >-->
<!--        </snelstart-ui-number-form-control>-->
<!--      </div>-->
<!--    </div>-->
<!--</form>-->
<form [formGroup]="totalWaardeverminderingVlottendeActivaFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Waardeverminderingen van vlottende activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalOverigeBedrijfskostenFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Overige bedrijfskosten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="somBedrijfslastenFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px"><b>Totaal van bedrijfslasten</b></p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<div class="pt-3"></div>
<form [formGroup]="somBedrijfsresultaatFg">
  <div class="row">
    <div class="col col-1 bold">Totaal van bedrijfsresultaat</div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<div class="pt-3"></div>
<form [formGroup]="totalVrijvalUitHerwaarderingsreserveFg">
  <div class="row" *ngIf="this.isRechtspersoon">
    <div class="col col-1">
      <p style="padding: 6px">Vrijval uit herwaarderingsreserve</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalFinancieleBatenLastenFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Financiële baten en lasten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<div class="pt-3" *ngIf="this.isRechtspersoon"></div>
<form [formGroup]="somResultaatVoorBelastingenFg">
  <div class="row" *ngIf="this.isRechtspersoon">
    <div class="col col-1 bold">Totaal van resultaat voor belastingen</div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<div class="pt-3" *ngIf="this.isRechtspersoon"></div>
<form [formGroup]="totalBelastingenFg">
  <div class="row" *ngIf="this.isRechtspersoon">
    <div class="col col-1">
      <p style="padding: 6px">Belastingen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalResultaatUitDeelnemingenFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Resultaat uit deelnemingen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<!--<><form [formGroup]="totalOverigeBatenLastenNaBelastingFg">-->
<!--    <div class="row" *ngIf="this.isRechtspersoon">-->
<!--      <div class="col col-1">-->
<!--        <p style="padding: 6px">Overige baten en lasten na belasting</p>-->
<!--      </div>-->
<!--        <div class="col-2">-->
<!--          <snelstart-ui-number-form-control formControlName="valuePeriod1"-->
<!--                                            class="custom-input-150 custom-readonly"-->
<!--                                            align="right"-->
<!--                                            prefix="€"-->
<!--                                            [showAllDecimals]="false"-->
<!--                                            [disabledControl]="true"-->
<!--          >-->
<!--          </snelstart-ui-number-form-control>-->
<!--        </div>-->
<!--        <div class="col-3">-->
<!--          <snelstart-ui-number-form-control formControlName="valuePeriod2"-->
<!--                                            class="custom-input-150 custom-readonly"-->
<!--                                            align="right"-->
<!--                                            prefix="€"-->
<!--                                            [showAllDecimals]="false"-->
<!--                                            [disabledControl]="true"-->
<!--          >-->
<!--          </snelstart-ui-number-form-control>-->
<!--        </div>-->
<!--    </div>-->
<!--</form></>-->
<div class="pt-3"></div>
<form [formGroup]="somTotaalResultaatFg">
  <div class="row" *ngIf="!this.isRechtspersoon">
    <div class="col col-1 bold">Totaal resultaat</div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="somResultaatNaBelastingenFg">
  <div class="row" *ngIf="this.isRechtspersoon">
    <div class="col col-1 bold">Totaal van resultaat na belastingen</div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
